<div class="app-layout" [class.sidebar-collapsed]="sidebarCollapsed">
  <!-- Mobile backdrop + drawer sidebar -->
  <div *ngIf="isAuthenticated && isMobile && mobileNavOpen" class="mobile-nav-backdrop" (click)="closeMobileNav()">
  </div>

  <div *ngIf="isAuthenticated && isMobile && mobileNavOpen" class="mobile-drawer">
    <app-sidebar *ngIf="showSidebar" [menuSections]="sidebarMenuSections" [userInfo]="sidebarUserInfo"
      [syncLabel]="syncLabel" [syncState]="syncState" [collapsed]="mobileSidebarCollapsed"
      (collapsedChange)="onMobileSidebarCollapsedChange($event)" (userClicked)="showUserMenu($event)"></app-sidebar>
  </div>

  <!-- Desktop Sidebar Navigation -->
  <app-sidebar *ngIf="isAuthenticated && !isMobile && showSidebar" [menuSections]="sidebarMenuSections"
    [userInfo]="sidebarUserInfo" [syncLabel]="syncLabel" [syncState]="syncState" [(collapsed)]="sidebarCollapsed"
    (userClicked)="showUserMenu($event)"></app-sidebar>

  <!-- Main Content Area -->
  <div class="main-area" [class.no-sidebar]="!isAuthenticated || !showSidebar">
    <!-- Mobile Header (only on mobile) -->
    <header class="mobile-header" *ngIf="isAuthenticated && showSidebar">
      <button class="mobile-menu-btn" (click)="toggleMobileSidebar()">
        <i class="pi pi-wallet"></i>
      </button>
      <span class="mobile-title">CashZap</span>
      <div class="mobile-sync" [class]="'state-' + syncState" title="{{ syncLabel }}">
        <span class="dot"></span>
        <span class="label">{{ syncLabel }}</span>
      </div>
    </header>

    <!-- Page Content -->
    <main class="page-content">
      <router-outlet></router-outlet>
    </main>

    <!-- Footer -->
    <footer class="app-footer">
      <div class="footer-content">
        <span>&copy; {{ currentYear }} CashZap</span>
        <span class="version">v{{ version }}</span>
        <div *ngIf="isMockMode" class="mock-data-indicator">
          <span class="mock-label">MOCK DATA</span>
          <button pButton icon="pi pi-refresh" label="Reset Mock Data" (click)="resetMockData()"
            class="p-button-text p-button-sm reset-mock-btn"></button>
        </div>
      </div>
    </footer>
  </div>

  <!-- User Menu Overlay -->
  <p-menu #userMenu [model]="profileItems" [popup]="true"></p-menu>
</div>